<template>
  <div />
</template>

<script>
export default {
  name: 'FestivalDecorateRedirect',
  created() {
    this.$router.replace({ path: '/festival/decorate', query: this.$route.query })
  }
}
</script>
